import {
    Box,
    Button,
    FormControl,
    FormLabel,
    Input,
    Radio,
    RadioGroup,
    Stack,
    VStack
} from '@chakra-ui/react'
import dayjs from 'dayjs'
import { useState } from 'react'
import Download from '../../../../components/Icon/Download'
import { ContentFormProps } from './types'

export default function ContentForm({ onSubmit, isLoading }: ContentFormProps) {
    const [startDate, setStartDate] = useState(() =>
        dayjs().set('D', 1).format('YYYY-MM-DD')
    )
    const [endDate, setEndDate] = useState(() => {
        const date = new Date()
        date.setMonth(date.getMonth() + 1)
        date.setDate(0)
        return dayjs(date).format('YYYY-MM-DD')
    })
    const [report, setReport] = useState('')

    return (
        <form onSubmit={onSubmit}>
            <VStack w="full" mb={8} spacing={4}>
                <FormControl>
                    <FormLabel>De</FormLabel>
                    <Input
                        type="date"
                        name="startDate"
                        value={startDate}
                        max={endDate}
                        onChange={ev => setStartDate(ev.target.value)}
                    />
                </FormControl>
                <FormControl>
                    <FormLabel>Hasta</FormLabel>
                    <Input
                        type="date"
                        name="endDate"
                        min={startDate}
                        value={endDate}
                        onChange={ev => setEndDate(ev.target.value)}
                    />
                </FormControl>
                <FormControl>
                    <FormLabel>Reporte</FormLabel>
                    <RadioGroup value={report} onChange={setReport}>
                        <Stack>
                            <Radio name="report" value="1">
                                Ventas por productos
                            </Radio>
                            <Radio name="report" value="2">
                                Ventas por categorías
                            </Radio>
                            <Radio name="report" value="3">
                                Cortesías
                            </Radio>
                        </Stack>
                    </RadioGroup>
                </FormControl>
            </VStack>
            <Box textAlign="center">
                <Button
                    variant="alo-gray:md-xl"
                    isLoading={isLoading}
                    isDisabled={!report || !startDate || !endDate}
                    type="submit"
                    rightIcon={<Download fill="white" />}
                >
                    Descargar
                </Button>
            </Box>
        </form>
    )
}
